/** Human-readable labels for futures wallet `transaction_type`. */
export const FUTURES_WALLET_TX_TYPE_LABELS = {
    TRANSFER_IN: "Transfer In",
    TRANSFER_OUT: "Transfer Out",
    TRADING_FEE: "Trading Fee",
    REALIZED_PNL: "Realized PnL",
    FUNDING: "Funding Payment",
    TRANSFER: "Transfer",
    TRADE: "Trade",
    FEE: "Fee",
    PNL: "PnL",
};

export const FUTURES_WALLET_TX_TYPE_OPTIONS = [
    { value: "", label: "All Types" },
    { value: "TRANSFER", label: "Transfer" },
    { value: "TRANSFER_IN", label: "Transfer In" },
    { value: "TRANSFER_OUT", label: "Transfer Out" },
    { value: "TRADE", label: "Trade" },
    { value: "FEE", label: "Fee" },
    { value: "TRADING_FEE", label: "Trading Fee" },
    { value: "PNL", label: "PnL" },
    { value: "REALIZED_PNL", label: "Realized PnL" },
    { value: "FUNDING", label: "Funding Payment" },
];

export function formatFuturesWalletTxType(type) {
    const key = String(type ?? "").toUpperCase();
    return FUTURES_WALLET_TX_TYPE_LABELS[key] || key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) || "—";
}

/** Signed amount string from positive `amount` + `direction` (CREDIT / DEBIT). */
export function formatFuturesWalletTxAmount(amount, direction, { decimals = 4 } = {}) {
    const n = Number(amount);
    if (!Number.isFinite(n)) return "—";
    const dir = String(direction ?? "").toUpperCase();
    const signed = dir === "CREDIT" ? n : dir === "DEBIT" ? -Math.abs(n) : n;
    const absStr = Math.abs(signed).toFixed(decimals);
    return signed >= 0 ? `+${absStr}` : `-${absStr}`;
}

export function futuresWalletTxAmountClass(direction) {
    const dir = String(direction ?? "").toUpperCase();
    if (dir === "CREDIT") return "agce-ft-pnl--profit";
    if (dir === "DEBIT") return "agce-ft-pnl--loss";
    return "";
}

export const FUTURES_WALLET_HISTORY_DEFAULT_FILTERS = {
    type: "",
    asset: "",
    symbol: "",
    from: "",
    to: "",
    page: 1,
    limit: 20,
};
